class RecentSalesShowcase extends HTMLElement {
  connectedCallback() {
    this.endpoint = this.dataset.endpoint;
    this.interval = (parseInt(this.dataset.interval, 10) || 25) * 1000;
    this.limit = parseInt(this.dataset.limit, 10) || 10;
    this.cardsPerPage = parseInt(this.dataset.cardsDesktop, 10) || 3;
    this.sales = [];
    this.currentIndex = 0;
    this.timer = null;

    this.stage = this.querySelector('[data-recent-sales-showcase-stage]');
    this.progress = this.querySelector('[data-recent-sales-showcase-progress]');

    if (!this.endpoint) return;

    this.fetchAndRender();
    setInterval(() => this.fetchAndRender(), 60000);
  }

  async fetchAndRender() {
    try {
      const response = await fetch(this.endpoint);
      if (!response.ok) return;
      const data = await response.json();
      if (!Array.isArray(data)) return;
      this.sales = data.slice(0, this.limit);
      this.renderPages();
    } catch (e) {
      /* endpoint unavailable, leave existing state (empty message) */
    }
  }

  groupIntoPages() {
    const size = Math.max(1, this.cardsPerPage);
    const pages = [];
    for (let i = 0; i < this.sales.length; i += size) {
      pages.push(this.sales.slice(i, i + size));
    }
    return pages;
  }

  renderPages() {
    if (this.sales.length === 0) {
      this.stage.innerHTML = '<p class="recent-sales-showcase__empty">Aucune vente recente pour le moment.</p>';
      this.progress.innerHTML = '';
      if (this.timer) clearInterval(this.timer);
      return;
    }

    const pages = this.groupIntoPages();

    this.stage.innerHTML = pages
      .map(
        (page, pageIndex) => `
        <div class="recent-sales-showcase__page${pageIndex === 0 ? ' recent-sales-showcase__page--active' : ''}" data-index="${pageIndex}">
          ${page.map((sale) => this.renderCard(sale)).join('')}
        </div>
      `
      )
      .join('');

    this.progress.innerHTML = pages
      .map((_, index) => `<span class="recent-sales-showcase__progress-dot${index === 0 ? ' recent-sales-showcase__progress-dot--active' : ''}"></span>`)
      .join('');

    this.currentIndex = 0;
    if (this.timer) clearInterval(this.timer);
    if (pages.length > 1) {
      this.timer = setInterval(() => this.showNext(), this.interval);
    }
  }

  renderCard(sale) {
    const tag = sale.handle ? 'a' : 'div';
    const href = sale.handle ? ` href="/products/${this.escapeHtml(sale.handle)}"` : '';
    return `
      <${tag}${href} class="recent-sales-showcase__card">
        <span class="recent-sales-showcase__image">
          ${sale.image ? `<img src="${sale.image}" alt="${this.escapeHtml(sale.product)}" loading="lazy" width="260" height="260">` : ''}
        </span>
        <span class="recent-sales-showcase__eyebrow">
          <span class="recent-sales-showcase__dot" aria-hidden="true"></span>
          Vente recente
        </span>
        <span class="recent-sales-showcase__text">
          <strong>Quelqu'un &agrave; ${this.escapeHtml(sale.city)}</strong> vient d'acheter ${this.escapeHtml(sale.product)}
        </span>
      </${tag}>
    `;
  }

  showNext() {
    const pages = this.stage.querySelectorAll('.recent-sales-showcase__page');
    const dots = this.progress.querySelectorAll('.recent-sales-showcase__progress-dot');
    if (pages.length === 0) return;

    pages[this.currentIndex].classList.remove('recent-sales-showcase__page--active');
    dots[this.currentIndex].classList.remove('recent-sales-showcase__progress-dot--active');

    this.currentIndex = (this.currentIndex + 1) % pages.length;

    pages[this.currentIndex].classList.add('recent-sales-showcase__page--active');
    dots[this.currentIndex].classList.add('recent-sales-showcase__progress-dot--active');
  }

  escapeHtml(text) {
    const div = document.createElement('div');
    div.textContent = text == null ? '' : String(text);
    return div.innerHTML;
  }
}

if (!customElements.get('recent-sales-showcase')) {
  customElements.define('recent-sales-showcase', RecentSalesShowcase);
}
